export const NAVS = {
    INDEX: "Главная",
    FEATURES: {
        INDEX: "Возможности",
    },
    DEMO: {
        INDEX: "Демо",
    },
    BLOG: {
        INDEX: "Блог",
    },
    BOT: {
        INDEX: "Telegram-бот",
    },
    TOOLS: {
        INDEX: "Инструменты",
    },
    MONEY: {
        INDEX: "Денежные расходы",
    },
    MAINTENANCE: {
        INDEX: "Учёт ТО",
    },
    SERVICE_PROVIDERS: {
        INDEX: "Сервисные точки",
    },
    PLAN: {
        INDEX: "План ТО",
    },
    FUEL: {
        INDEX: "Заправки",
    },
    TRIP_CALCULATOR: {
        INDEX: "Калькулятор поездки",
    },
    ROUTE_DISTANCE: {
        INDEX: "Расстояние между городами",
    },
    MILEAGE: {
        INDEX: "Пробег",
    },
    NOTES: {
        INDEX: "Заметки",
    },
    PRIVACY: {
        INDEX: "Политика конфиденциальности",
    },
    AGREEMENT: {
        INDEX: "Пользовательское соглашение",
    },
    ERROR: {
        INDEX: "Ошибка",
    },
};
